import { SearchBox } from "./InputBox"
import { Link } from "react-router-dom"

const Header = () => {
  return (
    <div className="top_panel">
      <Link to='/main'><div className="logo" /></Link>
      <div className="menu">
        <a><div className="menu_block">About</div></a>
        <a><div className="menu_block">Match-Up</div></a>
        <a><div className="menu_block">Schedule</div></a>
        <Link to='/leaderboard'><div className="menu_block">Leaderboard</div></Link>
        <Link to='/team-leaderboard'><div className="menu_block">Standings</div></Link> {/* 團隊成績 */}
        <Link to='/roster'><div className="menu_block">Players</div></Link>
        <a><div className="menu_block">Teams</div></a>
        <Link to='/filter'><div className="menu_block">Filter</div></Link>
        <a><div className="menu_block">Stream</div></a>
      </div>
      <SearchBox placeholder="Search" />
    </div>
  )
}

export default Header